var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KTextbox',{scopedSlots:_vm._u([{key:"label",fn:function(){return [_c('span',{staticClass:"visuallyhidden"},[_vm._v("Label text")])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }